import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class ProjectLanguageService {
  constructor(private http: HttpClient) {}

  public put(params: any) {
    let projectId;
    let language;

    [params, projectId, language] = splayParams(
      params,
      "projectId",
      "language",
    );
    const url = `/api/v4/projects/${projectId}`;

    return this.http.put(url, { language });
  }
}
